import React, { useRef, useEffect } from "react";

const HighlightedText = ({ text, highlight }) => {
  if (!highlight) {
    return <>{text}</>;
  }

  const cleanedHighlight = highlight.replace(/[.*+-?^${}()|[\]\\]/g, "");
  const searchTerms = cleanedHighlight.toLowerCase().split(" ");
  const regex = new RegExp(`(${searchTerms.join("|")})`, "gi");
  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) =>
        searchTerms.includes(part.toLowerCase()) ? (
          <span
            key={index}
            id={`text-highlight-${index}`}
            data-testid={`text-highlight-${index}`}
            style={{ backgroundColor: "yellow" }}
          >
            {part}
          </span>
        ) : (
          part
        )
      )}
    </>
  );
};

const TextView = ({
  setEditedText,
  editedText,
  isEditing,
  searchText,
}) => {
  const textareaRef = useRef(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
    }
  }, [editedText, isEditing]);

  const ValueTextArea = searchText ? (
    <span id="textview-highlight-container">
      <HighlightedText
        text={editedText}
        highlight={searchText}
      />
    </span>
  ) : (
    <div id="textview-content">
      {editedText}
    </div>
  );

  return (
    <div
      id="textview-container"
      className="bg-white shadow-md"
    >
      {isEditing ? (
        <div
          id="textview-editor-container"
          className="border border-gray-300 rounded-lg"
        >
          <textarea
            ref={textareaRef}
            id="textview-editor-textarea"
            name="textView.editedText"
            data-testid="textview-editor-textarea"
            className="text-justify wrap-text mx-4 focus:outline-none focus:ring focus:ring-blue-300 focus:px-2"
            style={{
              width: "100%",
              maxHeight: "100vh",
              overflowY: "auto",
              resize: "none",
            }}
            value={editedText}
            onChange={(e) => setEditedText(e.target.value)}
          />
        </div>
      ) : (
        <pre
          id="textview-preview"
          data-testid="textview-preview"
          className="border border-gray-300 rounded-lg text-left whitespace-pre-wrap"
          style={{
            width: "100%",
            maxHeight: "100vh",
            overflowY: "auto",
            resize: "none",
          }}
        >
          <div
            id="textview-preview-content"
            className="mx-4"
          >
            {ValueTextArea}
          </div>
        </pre>
      )}
    </div>
  );
};

export default TextView;